<template>
	<mu-row class="text-center">
		<mu-col>
			<h3 class="m-2">{{title | capital_Letter}}</h3>
		</mu-col>
	</mu-row>
</template>

<script>

export default {
	props: ['title'],
	filters: {
		capital_Letter: function (title) {
			return title.toUpperCase();
		}
	}
}
</script>

<style>
</style>